"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMaxCharacters = void 0;
/**
 * Takes two numbers and returns the number of digits of the number with more characters.
 *
 * @param {Number} firstValue the first number to compare number of characters
 * @param {Number} secondValue the second number to compare number of characters
 */
function parseMaxCharacters(firstValue, secondValue) {
    var firstValueCharacters = countDigits(firstValue) + (isNegative(firstValue) ? 1 : 0);
    var secondValueCharacters = countDigits(secondValue) + (isNegative(secondValue) ? 1 : 0);
    return Math.max(firstValueCharacters, secondValueCharacters);
}
exports.parseMaxCharacters = parseMaxCharacters;
/**
 * Takes a number and returns the number of its digits
 *
 * @param {Number} originalValue the number to count the digits of
 */
function countDigits(originalValue) {
    var digitCount = 0;
    var absoluteValue = Math.abs(originalValue);
    while (absoluteValue / 10 >= 1) {
        absoluteValue /= 10;
        digitCount++;
    }
    return 1 + digitCount;
}
function isNegative(value) {
    return value < 0;
}
